import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { getAllCartItems } from "./addToCart";

const initialState = {
    isLoading: false,
    error: null,
    wishlist: [],
    deleteStatus: false,
};

const getHeaders = () => {
    const accessToken = typeof window !== "undefined" ? localStorage.getItem("accessToken") : "";
    return {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
    };
};

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
            state.error = null;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getWishlistSuccess(state, action) {
            state.isLoading = false;
            state.wishlist = action.payload;
        },
        deleteCartSuccess(state, action) {
            state.isLoading = false;
            state.deleteStatus = action.payload;
        },
    },
});

export const { startLoading, hasError, deleteCartSuccess, getWishlistSuccess } = wishlistSlice.actions;

export default wishlistSlice.reducer;

export const fetchUserWishlists = (user_id, toast) => async (dispatch) => {
  try {
    const res = await axios.get(`/wishlists/user/${user_id}`, {
      headers: getHeaders(),
    });
    return res.data;
  } catch (error) {
    toast?.error("Failed to load wishlists");
    return null;
  }
};

// Create a new wishlist
export const createWishlist = (user_id, name, toast) => async () => {
  try {
    const res = await axios.post(
      `/wishlists/save`,
      { user_id, name },
      { headers: getHeaders() }
    );
    toast?.success("New list created");
    return res.data;
  } catch (error) {
    toast?.error("Failed to create wishlist");
    return null;
  }
};

// Add product to wishlist
export const addToWishlist = (wishlist_id, productData, toast) => async () => {
  try {
    const res = await axios.post(
      `/wishlists/items`,
      {
        wishlist_id,
        ...productData,
      },
      { headers: getHeaders() }
    );
    toast?.success("Product added to wishlist");
    return res.data;
  } catch (error) {
    toast?.error("Failed to add item to wishlist");
    return null;
  }
};

// Remove product from wishlist
export const removeFromWishlist = (itemId, toast) => async () => {
  try {
    const res = await axios.delete(`/wishlists/items/${itemId}`, {
      headers: getHeaders(),
    });
    toast?.success("Item removed");
    return res.data;
  } catch (error) {
    toast?.error("Failed to remove item");
    return null;
  }
};

// Remove entire list
export const removeFromListApi = (wishlistId, toast) => async () => {
  try {
    const res = await axios.delete(`/wishlists/${wishlistId}/delete`, {
      headers: getHeaders(),
    });
    toast?.success("List removed successfully");
    return res.data;
  } catch (error) {
    toast?.error("Failed to remove list");
    return null;
  }
};

// Update quantity in wishlist
export const updateWishlistQuantity = (itemId, quantity, notify) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/wishlist-item/${itemId}/update-quantity`,
        { quantity },
        { headers: getHeaders() }
      );

      if (res.data?.success) {
        notify.success("Quantity updated successfully.");
        return res.data;
      } else {
        notify.error("Failed to update quantity.");
        return null;
      }
    } catch (error) {
      notify.error("Error updating quantity.");
      return null;
    }
  };
};

